"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _request = _interopRequireDefault(require("./request"));

var _response = _interopRequireDefault(require("./response"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PlaidClient =
/*#__PURE__*/
function () {
  function PlaidClient() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$environment = _ref.environment,
        environment = _ref$environment === void 0 ? 'sandbox' : _ref$environment,
        public_key = _ref.public_key;

    _classCallCheck(this, PlaidClient);

    this.baseURL = 'https://sandbox.plaid.com';
    this.public_key = public_key;

    switch (environment) {
      case 'sandbox':
        this.baseURL = 'https://sandbox.plaid.com/';
        break;

      case 'development':
        this.baseURL = 'https://development.plaid.com/';
        break;

      case 'production':
        this.baseURL = 'https://production.plaid.com/';
        break;
    }
  }

  _createClass(PlaidClient, [{
    key: "_fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(fragment, method, data, urlParams) {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _request["default"])({
                  base: this.baseURL,
                  params: urlParams,
                  fragment: fragment,
                  method: method,
                  data: data
                });

              case 2:
                response = _context.sent;
                _context.next = 5;
                return (0, _response["default"])(response);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _fetch(_x, _x2, _x3, _x4) {
        return _fetch2.apply(this, arguments);
      }

      return _fetch;
    }()
  }, {
    key: "getInstitution",
    value: function () {
      var _getInstitution = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(institution_id) {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = {
                  institution_id: institution_id,
                  public_key: this.public_key,
                  options: {
                    include_display_data: true
                  }
                };
                _context2.next = 3;
                return this._fetch('/institutions/get_by_id', 'POST', data);

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getInstitution(_x5) {
        return _getInstitution.apply(this, arguments);
      }

      return getInstitution;
    }()
  }]);

  return PlaidClient;
}();

exports["default"] = PlaidClient;